import React from 'react'
import { Row, Col } from 'antd'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import apiRequest from '../hooks/ApiRequest'
class Home extends React.Component {
  constructor() {
    super()
    this.state = {
      role: JSON.parse(localStorage.getItem('roles')),
      username: localStorage.getItem('username'),
      loggedInUserID: parseInt(localStorage.getItem('loggedInUserID')),
      productList: [],
    }
  }
  fetchData = async () => {
    debugger;

    if (this.state.role === 'InsurerAdmin') {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerId/${this.state.loggedInUserID}`,
        'GET'
      )

      if (response.success) {
        let result = response?.data.map(item => ({
          productid: item.genericProductId,
          productname: item.productName,
        }));
        this.setState({ productList: result })
      }
      else {
        this.setState({ loading: false });
      }
    }
    else if (this.state.role === 'Broker') {
      const brokerPayload = [parseInt(this.state.loggedInUserID)];
      const insurerRes = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetInsurersByBrokerId`,
        'POST',
        brokerPayload
      );

      if (insurerRes.success && insurerRes?.data?.length > 0) {
        debugger;
        const insurerIDs = insurerRes.data.map(x => x.id);
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIds`,
          'POST',
          insurerIDs
        );

        if (response.success) {
          debugger;
          let result = response?.data.map(item => ({
            productid: item.genericProductId,
            productname: item.productName,
          }));
          this.setState({ productList: result })
        }

      }
    }
    else {
      const response = await apiRequest(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts', 'GET');

      if (response.success) {
        this.setState({ productList: response?.data?.data })
      }
      else {
        this.setState({ loading: false });
      }
    }
  }
  componentDidMount() {
    this.fetchData();
  }

  handleClick = (data) => {
    localStorage.setItem('productId', data.productid)
    localStorage.setItem('productName', data.productname)
    this.props.history.push('/dashboard')
  }

  render() {
    return (
      <div className=" ant-layout-content">
        <div className="dashboard-heading-top cards-heading text-center">
          <h1> </h1>
          <p>Please select a Product</p>
        </div>
        <Row gutter={[16, 16]}>
          {this.state.productList.map((value, index) => (
            <Col
              key={index}
              xs={24}   // Full width on extra small screens (mobile)
              sm={12}   // 2 columns on small screens (tablet)
              md={8}    // 3 columns on medium screens (desktop)
              lg={8}    // 3 columns on large screens (desktop)
              className="custom-statcards buttons"
            >
              <button
                onClick={() => this.handleClick(value)}
                className="primary card-body-bx yellow-bg text-left"
              >
                <h4>{value.productname}</h4>
                <div className="card-icon-bx">
                  <img className='productImg' src={require('../static/images/assets.png')} />
                </div>
              </button>
            </Col>
          ))}
        </Row>

      </div>
    )
  }
}

export default withRouter(Home) 
